import { render } from "./DashboardLayout.vue?vue&type=template&id=2adebc49&ts=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__